/* tslint:disable */
/* eslint-disable */
/**
 * Stacks Blockchain API
 * Welcome to the API reference overview for the [Stacks Blockchain API](https://docs.hiro.so/stacks-blockchain-api).  [Download Postman collection](https://hirosystems.github.io/stacks-blockchain-api/collection.json) 
 *
 * The version of the OpenAPI document: STACKS_API_VERSION
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * The operation_identifier uniquely identifies an operation within a transaction.
 * @export
 * @interface RosettaOperationIdentifier
 */
export interface RosettaOperationIdentifier {
    /**
     * The operation index is used to ensure each operation has a unique identifier within a transaction. This index is only relative to the transaction and NOT GLOBAL. The operations in each transaction should start from index 0. To clarify, there may not be any notion of an operation index in the blockchain being described.
     * @type {number}
     * @memberof RosettaOperationIdentifier
     */
    index: number;
    /**
     * Some blockchains specify an operation index that is essential for client use. For example, Bitcoin uses a network_index to identify which UTXO was used in a transaction. network_index should not be populated if there is no notion of an operation index in a blockchain (typically most account-based blockchains).
     * @type {number}
     * @memberof RosettaOperationIdentifier
     */
    network_index?: number;
}

export function RosettaOperationIdentifierFromJSON(json: any): RosettaOperationIdentifier {
    return RosettaOperationIdentifierFromJSONTyped(json, false);
}

export function RosettaOperationIdentifierFromJSONTyped(json: any, ignoreDiscriminator: boolean): RosettaOperationIdentifier {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'index': json['index'],
        'network_index': !exists(json, 'network_index') ? undefined : json['network_index'],
    };
}

export function RosettaOperationIdentifierToJSON(value?: RosettaOperationIdentifier | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'index': value.index,
        'network_index': value.network_index,
    };
}

